export default class CreateIssueError extends Error {

}